import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { getComments } from 'cd-eft/components/Projects/Project/ProjectVM'

const libraryStore = stores.AppStore.projectsLibraryStore;

export class ProjectCommentsVM {
  @observable props;
  @observable projectId: string;
  @observable newProjectComment: any = {
    projectComment: '',
  };
  @observable editedProjectComment: any = {
    comment: '',
    commentTypeId: ''
  };
  @observable deleteProjectcommentsData: any = [];
  @observable readOnlyForm: boolean = true;
  @observable addFormVisible: boolean = false;
  @observable editFormVisible: boolean = false;
  @observable editFormBtnVisible: boolean = false
  @observable deleteFormBtnVisible: boolean = false
  @observable editCheckboxes: boolean = false;
  @observable deleteCheckboxes: boolean = false;
  @observable cancelButton: boolean = false;
  @observable deletePopup: boolean = false;
  @observable targetId: any;
  @observable deletetargetId: any;
  @observable rowHeight: any;
  @observable logginUser: string = localStorage['username']
  @observable deleteDataLength = true;
  @observable isSaving = false;

  constructor(props) {
    this.props = props;
    this.projectId = this.props.projectId;
  }

  elementActions = {
    Edit: { action: this.toggleEditFormVisible },
    Delete: { action: this.toggleDeleteFormVisible },
    Add: { action: this.toggleAddFormVisible },
  };



  @action.bound toggleReadOnlyForm() {
    this.readOnlyForm = !this.readOnlyForm
  }

  @action.bound toggleAddFormVisible() {
    this.addFormVisible = !this.addFormVisible;
    this.editFormBtnVisible = false;
    this.editFormVisible = false;
    this.cancelButton = false;
    this.deleteFormBtnVisible = false;
    this.readOnlyForm = true;
    this.targetId = '';
  }

  @action.bound toggleEditFormVisible() {
    if (this.deleteCheckboxes || this.readOnlyForm || this.addFormVisible) {
      this.editCheckboxes = true;
      this.editFormVisible = true;
      this.editFormBtnVisible = true;
      this.cancelButton = true;
      this.readOnlyForm = false;
      this.addFormVisible = false;
      this.deleteFormBtnVisible = false;
      this.deleteCheckboxes = false;
      this.targetId = '';
      this.newProjectComment.projectComment = '';

    }
    else {
      this.cancelProjectComment();
    }
  }

  @action.bound cancelEditComment() {
    this.cancelButton = true;
    this.targetId = '';
  }

  @action.bound toggleDeleteFormVisible() {
    if (this.editCheckboxes || this.readOnlyForm || this.addFormVisible) {
      this.deleteCheckboxes = true;
      this.deleteFormBtnVisible = true;
      this.editFormVisible = true;
      this.editFormBtnVisible = false;
      this.cancelButton = false;
      this.readOnlyForm = false;
      this.addFormVisible = false;
      this.editCheckboxes = false;
      this.targetId = '';
      this.newProjectComment.projectComment = '';
    }
    else {
      this.cancelProjectComment()
    }
  }

  @action.bound toggleDeletePopup() {
    this.deletePopup = !this.deletePopup;
  }

  @action.bound handleDeleteCheckBox(event, data) {
   this.deletetargetId = Number(event.target.id);
    (data ? data : libraryStore.projectComments).forEach(comment => {
      if (comment.projectCommentId === this.deletetargetId) {
        if (event.target.checked) {
          this.deleteFormBtnVisible = true;
          this.deleteProjectcommentsData.push({
            projectUuid: this.projectId,
            projectCommentId: comment.projectCommentId,
            commentTypeId: comment.commentTypeId,
            workflowStep: "",
            commentAuthor: this.logginUser,
            projectComment: comment.projectComment,
            lastChangeDateUtc: comment.lastChangeDateUtc,
            creationDateUtc: comment.creationDateUtc,
            editStatus: "delete",
            prevEditStatus: comment.editStatus
          });
        } else {
          const indexOfObject = this.deleteProjectcommentsData.findIndex(
            comment => comment.projectCommentId === this.deletetargetId
          );
          this.deleteProjectcommentsData.splice(indexOfObject, 1);
        }
      }
    });
    this.deleteDataLength = this.deleteProjectcommentsData.length === 0;
  }

  @action.bound cancelProjectComment() {
    this.readOnlyForm = true;
    this.addFormVisible = false;
    this.editFormVisible = false;
    this.editFormBtnVisible = false;
    this.editCheckboxes = false;
    this.cancelButton = false;
    this.deleteFormBtnVisible = false;
    this.deleteCheckboxes = false;
    this.deletePopup = false;
    this.targetId = '';
    this.rowHeight = ''
    this.editedProjectComment.comment = '';
    this.newProjectComment.projectComment = '';
    this.deleteProjectcommentsData = [];
  }

  @action.bound handleCheckBox(event) {
    this.targetId = Number(event.target.id);
    (this.props.listAllComments ? this.props.allCommentsData : libraryStore.projectComments).forEach(projectComment => {
      if (projectComment.projectCommentId === this.targetId) {
        event.target.checked = true;
        this.editFormBtnVisible = true;
        this.cancelButton = false;
      }
    })
  }


  @action.bound handleInput(event) {
    event.preventDefault();
    const { name, value } = event.target;
    this.newProjectComment[name] = value;
    const numline = event.target.value.split(/\r\n|\r|\n/).length + 1
    this.rowHeight = numline;
  }

  @action.bound handleInputChange(event) {
    event.preventDefault();
    const { name, value, id } = event.target;
    this.editedProjectComment[name] = value;
    this.editedProjectComment.commentTypeId = id;
  }

  @action.bound async createProjectComments() {
    this.isSaving = true;
    if (this.newProjectComment.projectComment === '') {
      this.addFormVisible = false;
    }
    else {
      const postJSON = {
        projectUuid: this.projectId,
        commentTypeId: 1,
        workflowStep: "",
        commentAuthor: this.logginUser,
        projectComment: this.newProjectComment.projectComment,
        editStatus: "add"
      };

      try {
        await PRJAPI.ProjectCommentController.createProjectCommentByProjectUuidUsingPOST(postJSON)

      } catch (error) {
        MessageCenter.addError((error as Error).message);
      }

      this.addFormVisible = false;
      getComments(this.projectId);
      this.cancelProjectComment();
      this.props.updateCallback();
    }
    this.isSaving = false
  }

  @action.bound async editProjectComment(data?) {
    if (this.editedProjectComment.comment) {
      const postJSON = {
        projectUuid: this.projectId,
        projectCommentId: this.targetId,
        commentTypeId: this.editedProjectComment.commentTypeId,
        workflowStep: "",
        commentAuthor: this.logginUser,
        projectComment: this.editedProjectComment.comment,
        editStatus: "update"
      };
      if(this.props.listAllComments && this.editedProjectComment.commentTypeId === '2'){
        const requiredObj = data.findIndex(id=> id.projectCommentId === this.targetId);
        postJSON.workflowStep = data[requiredObj]?.workflowStep;
        };
      try {
        await PRJAPI.ProjectCommentController.editProjectCommentByProjectCommentIdUsingPOST(postJSON)
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      }
      getComments(this.projectId)
      this.cancelProjectComment();
      this.props.updateCallback();
    }
    else {
      this.cancelProjectComment()
    }
  }

  @action.bound async deleteProjectComments() {

    const postJSON = {
      projectCommentIdList: this.deleteProjectcommentsData.map(data => data.projectCommentId),
      projectUuid: this.projectId
    };
    try {
      await PRJAPI.ProjectCommentController.deleteProjectCommentsByProjectCommentIdsUsingPOST(postJSON)
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
    getComments(this.projectId)
    this.cancelProjectComment();
    this.props.updateCallback();
  }
}
